import React from "react";
import { useFormikContext } from "formik";

import FileField from "../../common/FileField";
import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import PleaseExplain from "../../common/PleaseExplain";
import InputField from "../../common/InputField";

const SignatureFields = () => {
  const { values } = useFormikContext();
  const isAbove = values.revenue === "More Than 30K";

  return (
    <FormStep>
      <FormSection title="O. Required Materials and File Uploads">
        <FileField label="1. W-9 Form" name="w9" />
        {isAbove && (
          <React.Fragment>
            <FileField
              label="2. Workers Compensation EMR"
              name="workersCompensationEMR"
            />
            <p>
              Experience Modification Rate from National Council on Compensation
              Insurance (NCCI)
            </p>
          </React.Fragment>
        )}
        <PleaseExplain name="haveEndingTraffickingPolicy">
          <FileField
            label={
              (isAbove ? "4. " : "3. ") +
              "Ending Trafficking in Persons Compliance Statement"
            }
            name="endingTraffickingPolicy"
          />
        </PleaseExplain>
        <PleaseExplain name="haveCodeOfBusinessEthicsAndConduct">
          <FileField
            label={"Code of Business Ethics and Conduct"}
            name="codeOfBusinessEthicsAndConduct"
          />
        </PleaseExplain>
        <PleaseExplain name="haveCodeTrainingMaterials">
          <FileField
            label={"Code Training Materials"}
            name="codeTrainingMaterials"
          />
        </PleaseExplain>

        {/* Security Section Documents */}
        <PleaseExplain name="compliantIT">
          <FileField label="IT NIST SP 800-171 Compliance File" name="compliantITFileName" />
        </PleaseExplain>
        <PleaseExplain name="canReviewSSP">
          <FileField label="SSP File" name="securitySystemPlanFileName" />
        </PleaseExplain>
        <PleaseExplain name="NISTSP800171Assessment">
          <FileField label="POAM SSP" name="NISTSP800171AssessmentFileName" />
        </PleaseExplain>
        {/* Security Section Documents */}
      </FormSection>

      <FormSection title="P. Ending Trafficking in Persons Compliance Statement / Authorization to Release Information">
        <p style={{ marginBottom: "2rem", marginTop: "1.5rem" }}>
          By submitting this application form, I certify that the responses
          herein are true and complete to the best of my knowledge and belief.
          Knowingly providing false or misleading statements will be grounds for
          disqualification of the application. I authorize Alutiiq to contact
          references noted or information provided herein for the purposes of
          verifying the qualifications of my company. I hereby release Alutiiq,
          LLC and its parent, subsidiaries, affiliates, and each of its and
          their respective former and current owners, shareholders, members,
          officers, directors, representatives, agents, employees, and
          successors and assigns from liability or damage that may result from
          furnishing the information requested.
        </p>
        <InputField label="1. First Name" name="signatureFirstName" />
        <InputField label="2. Last Name" name="signatureLastName" />
        <InputField label="3. Title" name="signatureTitle" />
        <InputField
          label="4. Date (MM/DD/YYYY)"
          name="signatureDate"
          required={true}
        />
      </FormSection>
    </FormStep>
  );
};

export default SignatureFields;
